import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/tabletoolbar
 */
import { Plugin } from 'ckeditor5/src/core.js';
import { WidgetToolbarRepository } from 'ckeditor5/src/widget.js';
import { getSelectedTableWidget, getTableWidgetAncestor } from './utils/ui/widget.js';
/**
 * The table toolbar class. It creates toolbars for the table feature and its content (for now only for the table cell content).
 *
 * The table toolbar shows up when a table widget is selected. Its components (e.g. buttons) are created based on the
 * {@link module:table/tableconfig~TableConfig#tableToolbar `table.tableToolbar` configuration option}.
 *
 * Table content toolbar shows up when the selection is inside the content of a table. It creates its component based on the
 * {@link module:table/tableconfig~TableConfig#contentToolbar `table.contentToolbar` configuration option}.
 */
var TableToolbar = /*#__PURE__*/function (_Plugin) {
  _inherits(TableToolbar, _Plugin);
  var _super = _createSuper(TableToolbar);
  function TableToolbar() {
    _classCallCheck(this, TableToolbar);
    return _super.apply(this, arguments);
  }
  _createClass(TableToolbar, [{
    key: "afterInit",
    value:
    /**
     * @inheritDoc
     */
    function afterInit() {
      var editor = this.editor;
      var t = editor.t;
      var widgetToolbarRepository = editor.plugins.get(WidgetToolbarRepository);
      var tableContentToolbarItems = editor.config.get('table.contentToolbar');
      var tableToolbarItems = editor.config.get('table.tableToolbar');
      if (tableContentToolbarItems) {
        widgetToolbarRepository.register('tableContent', {
          ariaLabel: t('Table toolbar'),
          items: tableContentToolbarItems,
          getRelatedElement: getTableWidgetAncestor
        });
      }
      if (tableToolbarItems) {
        widgetToolbarRepository.register('table', {
          ariaLabel: t('Table toolbar'),
          items: tableToolbarItems,
          getRelatedElement: getSelectedTableWidget
        });
      }
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [WidgetToolbarRepository];
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "pluginName",
    get: function get() {
      return 'TableToolbar';
    }
  }]);
  return TableToolbar;
}(Plugin);
export { TableToolbar as default };